import { observer } from 'mobx-react-lite'
import { Alert } from 'shared/ui'
import { type AssignNumberCommonStore } from 'entities/Phone'
import { type INextButtonProps, NextButton } from '../NextButton/NextButton'

type IAssignLaterProps = {
  store: AssignNumberCommonStore
  nextButtonProps?: INextButtonProps
}

export const AssignLater = observer(({ store, nextButtonProps }: IAssignLaterProps) => {
  const { nextClick, loadingButton, hideSubmit, disabledButton } = store

  return (
    <>
      <Alert
        item={{
          type: 'infoLight',
          title: 'The numbers will appear under the unassigned tab',
          desc: 'To call and send messages from these numbers, you’ll need to assign them to an inbox.',
        }}
      />

      {!hideSubmit && (
        <NextButton
          text='Next'
          disabled={disabledButton}
          loading={loadingButton}
          onClick={() => nextClick()}
          {...nextButtonProps}
        />
      )}
    </>
  )
})
